import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { FormControl, Validators } from "@angular/forms";

import { fuseAnimations } from "@fuse/animations";
import { map, Observable } from "rxjs";

import { ActionDialog, BaseComponent, LoadingTeste } from "../../base-module/base-component/base.component";

import { PageEvent } from "@angular/material/paginator";
import { TipoOportunidadeService } from "app/auxiliares/services/tipo-oportunidade-service";
import { IItemsPermissionActions } from "app/interfaces/IItemsPermissionActions";
import { ListaAtividadeAssuntoService } from "app/lista-atividades/services/lista-atividade-assunto.service";
import { ListaAtividadeService } from "app/lista-atividades/services/lista-atividades.service";
import { format } from "date-fns";
import { AcaoService } from "../../auxiliares/services/acao-service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { ClienteModel } from "../models/cliente.model";
import { ClienteOportunidadeService } from "../services/cliente-oportunidade.service";
import { ClienteRelacionentoService } from "../services/cliente-relacionamento.service";
import { ClienteService } from "../services/cliente.service";

export interface DialogData {
    valor: any;
    valor_sugerido: any;
    id: number;
    cliente_id: number;
    dados_cliente: object;
    only_show: boolean;
    atividade_cliente_id: number;
    is_assessor: boolean;
    user_id: number;
    servico_id: number;
    assunto_id: number;
    nome_assunto: string;
    resposta: string;
}

interface Actions {
    buttonAlterOportunit: IItemsPermissionActions;
    buttonAddOportunit: IItemsPermissionActions;
}

interface ModelTarefaResposta {
    resposta: string | null;
    valor: number | null;
    tarefa_id: number | null;
    cliente_aceitou: boolean;
    user_id: number | null;
    is_assessor: boolean;
}

interface ModelUpdate {
    id: number | null;
    resposta: string | null;
    assunto_id: number | null;
    cliente_aceitou: boolean | null;
    valor: number | null;
    tarefa_id: number | null;
    data_retorno: Date | null;
    resposta_id: number | null;
}

interface ModelDefault {
    cliente_id: number | null;
    assunto_id: number | null;
    acao_id: number | null;
    acao_retorno_id: number | null;
    data_follow_up: Date | null;
    observacao: string | null;
    resposta: string | null;
}

interface ModelTarefa {
    cliente_id: number | null;
    observacao: string | null;
    assunto_id: number | null;
    data_hora_atividade: Date | null;
    tarefa_id: number | null;
    valor_sugerido: number | null;
    is_assessor: boolean | null;
    servico_id: number | null;
}

@Component({
    selector: "app-cadastro-relacionamento-cliente",
    templateUrl: "./cadastro-relacionamento-cliente.component.html",
    styleUrls: ["./cadastro-relacionamento-cliente.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [AcaoService],
})
export class CadastroRelacionamentoClienteComponent extends BaseComponent implements OnInit {
    observacao = new FormControl("", [Validators.required]);
    resposta = new FormControl("", [Validators.required]);
    acao_id = new FormControl("", [Validators.required]);
    data_follow_up = new FormControl<Date | null>(null, [Validators.required]);
    cliente = new FormControl("");
    assunto_id = new FormControl("");
    data_hora_atividade = new FormControl("");
    resposta_id = new FormControl(null);

    descricao = new FormControl("");
    data_retorno = new FormControl(new Date());
    valor = new FormControl<number>(0);
    valor_sugerido = new FormControl<number>(0);
    tipo_oportunidade_id = new FormControl("");
    arquivos = new FormControl([]);
    arquivosSelecionados: File[] = [];
    isVisibleValor = false;

    model_tarefa_resposta: ModelTarefaResposta = {
        resposta: this.data.resposta,
        valor: 0.0,
        tarefa_id: this.data.atividade_cliente_id,
        cliente_aceitou: false,
        user_id: this.data.user_id,
        is_assessor: this.data.is_assessor,
    };

    modelUpdate: ModelUpdate = {
        id: null,
        resposta: this.data.resposta,
        assunto_id: null,
        cliente_aceitou: false,
        valor: 0.0,
        tarefa_id: this.data.atividade_cliente_id,
        data_retorno: null,
        resposta_id: null,
    };

    model: ModelDefault = {
        cliente_id: null,
        assunto_id: null,
        acao_id: null,
        acao_retorno_id: null,
        data_follow_up: null,
        observacao: null,
        resposta: null,
    };

    model_tarefa: ModelTarefa = {
        cliente_id: this.data.cliente_id,
        observacao: null,
        assunto_id: null,
        data_hora_atividade: null,
        tarefa_id: this.data.atividade_cliente_id,
        valor_sugerido: 0.0,
        is_assessor: this.data.is_assessor,
        servico_id: this.data.servico_id,
    };

    loadingLocal: any;
    loadingSpinnerAcao: boolean = false;
    loadingSpinnerAssunto: boolean = false;
    loadingSpinner: boolean = false;
    loadingSpinnerTipo: boolean = false;
    loadingIndicatorOportunidade: boolean = false;
    isVisibleAgendamentoFuturo: boolean = false;
    isVisibleOportunidade: boolean = false;
    listAcao: any[] = [];
    listAtividade: any[] = [];
    listTipo: any[] = [];
    filteredOptions!: Observable<ClienteModel[]>;
    showClientField: boolean = false;
    todayDate: Date = new Date();
    isOportunidade = false;
    isOportunidadeSend = false;
    cliente_aceitou = false;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;
    @ViewChild(CadastroRelacionamentoClienteComponent, { static: false })
    table!: CadastroRelacionamentoClienteComponent;

    @ViewChild("fileInputRef", { static: false })
    fileInput!: ElementRef<HTMLInputElement>;

    _actions: Actions = {
        buttonAlterOportunit: {
            permission: "Editar Oportunidade",
            enabled: false,
        },
        buttonAddOportunit: {
            permission: "Cadastrar Oportunidade",
            enabled: false,
        },
    };

    constructor(
        public service: ClienteRelacionentoService,
        public _tipoOportunidadeService: TipoOportunidadeService,
        public _serviceOportunidade: ClienteOportunidadeService,
        private _clienteService: ClienteService,
        private _listaAtividadeAssuntoService: ListaAtividadeAssuntoService,
        private _listaAtividade: ListaAtividadeService,
        private _acaoService: AcaoService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private loading: MatDialog,
        public authService: AuthService,
        public dialogRef: MatDialogRef<CadastroRelacionamentoClienteComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super(dialog, snackBar);

        if (this.data.id != null && this.data.id != undefined) {
            this.getById();
            this.isVisibleOportunidade = true;
        }

        this.listAcao = [];
        this.listAtividade = [];
        this.getAllAcao();
        this.getAllAssuntoListaAtividades();
    }

    ngOnInit(): void {
        this.verifyPermissionForActions();

        if (this.data.cliente_id == null || this.data.cliente_id == undefined) {
            this.showClientField = true;
            this.cliente.valueChanges.subscribe((query) => {
                if (typeof query === "string" || typeof query === "number") {
                    this.loadingSpinner = true;
                    this.params.search = query;
                    this.filteredOptions = this._clienteService
                        .search(this.params)
                        .pipe(map((response) => response.data));
                }
            });
        } else {
            this.showClientField = false;
        }
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event: PageEvent) {
        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;

        // this.getAll();
    }

    displayFn(cliente: any) {
        if (cliente) {
            return cliente.nome;
        }
    }

    getCliente(cliente: any) {
        this.loadingSpinner = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    /**
     * Abre loagind
     */
    openLoadingLocal(): void {
        this.loadingLocal = this.loading.open(LoadingTeste, {
            width: "150px",
            disableClose: true,
        });
    }

    /**
     * Fecha loagind
     */
    closeLoadingLocal(): void {
        if (this.loadingLocal != null) {
            this.loadingLocal.close();
        }
    }

    addOportunidade() {
        this.model_tarefa.observacao = this.observacao.value;
        this.model_tarefa.assunto_id = Number(this.assunto_id.value);
        this.model_tarefa.data_hora_atividade = this.data_follow_up.value;
        if (this.valor_sugerido.value) this.model_tarefa.valor_sugerido = this.valor_sugerido.value;

        if (
            this.model_tarefa.cliente_id &&
            this.model_tarefa.observacao &&
            this.model_tarefa.assunto_id &&
            this.model_tarefa.data_hora_atividade &&
            this.model_tarefa.tarefa_id
        ) {
            this._listaAtividade.create(this.objectToFormData(this.model_tarefa)).subscribe(
                (data) => {
                    this.getAllOportunidades();
                },
                (error) => {
                    this.showError(error.error.message);
                }
            );
        }
        this.data_follow_up.reset();
        this.data_follow_up.clearValidators();
        this.assunto_id.reset();
        this.assunto_id.clearAsyncValidators();
        this.observacao.reset();
        this.observacao.clearValidators();
        this.valor.setValue(0);

        this.isOportunidadeSend = true;
    }

    deleteOportunidade(id: any) {
        const lista = this;

        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir Contato Futuro",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.loadingIndicatorOportunidade = true;
                    lista._listaAtividade.delete(id).subscribe(
                        (data) => {
                            lista.showSuccess(data.message);
                            lista.getAllOportunidades();
                        },
                        (error) => {
                            lista.showError(error.error.message);
                        },
                        () => {
                            lista.loadingIndicatorOportunidade = false;
                        }
                    );
                },
            },
        });
    }

    isInvalidForm() {
        if (!this.resposta.valid) {
            return true;
        }

        return false;
    }

    canCancel() {
        if (this.isOportunidadeSend) return true;
        return false;
    }

    onToggleChange() {
        this.valor.setValue(0); // Reseta o valor para 0 quando o usuário alterna entre os botões
    }

    objectToFormData<T extends Record<string, any>>(obj: T): FormData {
        const formData = new FormData();

        Object.keys(obj).forEach((key) => {
            const value = obj[key];

            if (value !== null && value !== undefined) {
                if (value instanceof Date) {
                    formData.append(key, format(value ?? new Date(), "yyyy-MM-dd HH:mm:ss"));
                } else if (value !== null && value !== undefined) {
                    formData.append(key, String(value));
                }
            }
        });

        return formData;
    }

    salvar(verOportunidade: any) {
        this.openLoading();

        this.modelUpdate.id = this.data.atividade_cliente_id;
        this.modelUpdate.cliente_aceitou = this.cliente_aceitou;
        this.modelUpdate.assunto_id = this.data.assunto_id;
        this.modelUpdate.tarefa_id = this.data.atividade_cliente_id;

        if (this.resposta.value) this.modelUpdate.resposta = this.resposta.value;
        if (this.resposta_id.value) this.modelUpdate.resposta_id = this.resposta_id.value;
        if (this.valor.value) this.modelUpdate.valor = this.valor.value;

        // Converte o objeto em um FormData
        const formData = this.objectToFormData(this.modelUpdate);

        //Adiciona os arquivos selecionados
        for (let i = 0; i < this.arquivosSelecionados.length; i++) {
            formData.append("arquivos[]", this.arquivosSelecionados[i]);
        }

        if (this.modelUpdate.resposta) {
            this._listaAtividade.update(this.modelUpdate.id, formData).subscribe(
                (data) => {
                    this.closeLoading();
                    this.getById();

                    if (verOportunidade) {
                        this.isVisibleOportunidade = true;
                    } else {
                        this.dialogRef.close(data);
                        this.isVisibleOportunidade = false;
                    }
                },
                (error) => {
                    this.closeLoading();
                    this.showError(error.error.message);
                },
                () => {
                    this.closeLoading();
                }
            );
        }
    }

    getErrorObservacaoMessage() {
        return this.observacao.hasError("required") ? "Observação é um campo obrigatório" : "";
    }
    getErrorRespostaMessage() {
        return this.resposta.hasError("required") ? "Resposta é um campo obrigatório" : "";
    }
    getErrorAcaoMessage() {
        return this.acao_id.hasError("required") ? "Ação é um campo obrigatório" : "";
    }

    toggleOportunidade() {
        if (!this.isOportunidade) {
            this.valor.reset(); // Zera o campo Valor
            this.valor.clearValidators(); // Remove a obrigatoriedade
        } else {
            this.valor.setValidators(Validators.required); // Torna o campo obrigatório em Oportunidade
        }
        this.valor.updateValueAndValidity(); // Atualiza a validação
    }

    isInvalidFormOportunidade() {
        if (!this.assunto_id) {
            return true;
        }
        if (!this.observacao.valid) {
            return true;
        }

        if (!this.tipo_oportunidade_id.valid) {
            return true;
        }

        if (!this.data_follow_up.valid) {
            return true;
        }

        return false;
    }

    getById() {
        this.openLoading();
        this._listaAtividade.getById(this.data.id).subscribe(
            (item) => {
                this.model = item.data;
                this.modelUpdate = item.data;
                this.acao_id.setValue(item.data.acao_id);
                this.assunto_id.setValue(item.data.assunto_id);
                this.observacao.setValue(item.data.observacao);
                this.cliente.setValue(item.data.cliente);
                this.resposta.setValue(item.data.resposta);
                this.resposta_id.setValue(item.data.tarefas_respostas_usuarios?.id ?? null);
            },
            (error) => {
                this.closeLoading();
            },
            () => {
                this.closeLoading();
            }
        );
    }

    getAllAcao() {
        this.loadingSpinnerAcao = true;
        this._acaoService.getAll({}).subscribe(
            (list) => {
                this.listAcao = list.data;
            },
            (error) => { },
            () => {
                this.loadingSpinnerAcao = false;
            }
        );
    }

    getAllOportunidades() {
        this.loadingIndicatorOportunidade = true;

        this.params.tarefa_id = this.data.atividade_cliente_id;
        this.params.is_assessor = this.data.is_assessor;

        this._listaAtividade.getAll(this.params).subscribe(
            (data) => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            (error) => {
                this.loadingIndicatorOportunidade = false;
            },
            () => {
                this.loadingIndicatorOportunidade = false;
            }
        );
    }

    getAllAssuntoListaAtividades() {
        this.loadingSpinnerAssunto = true;
        this._listaAtividadeAssuntoService.getLista({ is_subject_prosperidade: false }).subscribe(
            (list) => {
                this.listAtividade = list.data;
            },
            (error) => { },
            () => {
                this.loadingSpinnerAssunto = false;
            }
        );
    }

    alternarCampoValor() {
        this.isVisibleValor = !this.isVisibleValor;

        if (this.isVisibleValor) {
            // Torna o campo obrigatório
            this.valor.setValidators([Validators.required]);
        } else {
            // Remove o valor e a validação de obrigatoriedade
            this.valor.reset();
            this.valor.clearValidators();
        }

        // Atualiza o estado do controle de formulário para aplicar as mudanças
        this.valor.updateValueAndValidity();
    }

    verifyPermissionForActions() {
        this._actions.buttonAlterOportunit.enabled = this.authService.isPermissao([
            this._actions.buttonAlterOportunit.permission,
        ]);
        this._actions.buttonAddOportunit.enabled = this.authService.isPermissao([
            this._actions.buttonAddOportunit.permission,
        ]);
    }

    addContatoFuturo() {
        this.isVisibleAgendamentoFuturo = !this.isVisibleAgendamentoFuturo;
        if (this.isVisibleAgendamentoFuturo) {
            // Torna o campo obrigatório
            this.data_follow_up.setValidators([Validators.required]);
            this.assunto_id.setValidators([Validators.required]);
            this.observacao.setValidators([Validators.required]);
        } else {
            // Remove o valor e a validação de obrigatoriedade
            this.data_follow_up.reset();
            this.data_follow_up.clearValidators();
            this.assunto_id.reset();
            this.assunto_id.clearAsyncValidators();
            this.observacao.reset();
            this.observacao.clearValidators();
            this.valor.reset();
            this.valor.clearValidators();
        }

        // Atualiza o estado do controle de formulário para aplicar as mudanças
        this.data_follow_up.updateValueAndValidity();
        this.assunto_id.updateValueAndValidity();
        this.observacao.updateValueAndValidity();
        this.valor.updateValueAndValidity();

        if (!this.isVisibleAgendamentoFuturo) {
            this.data_follow_up.setValue(null);
            this.assunto_id.setValue("");
            this.observacao.setValue("");
        }
    }
    formatarValor(event: any) {
        // Previne a recursão infinita ao alterar o valor
        const valorAtual = this.valor.value;

        // Remove 'R$' e formata o valor
        const novoValor = event.target.value;

        // Atualiza o valor apenas se for diferente do atual
        if (novoValor !== valorAtual) {
            this.valor.setValue(novoValor);
        }
    }

    onFileSelected(event: any) {
        if (event.target.files.length > 0) {
            for (const file of event.target.files) {
                this.arquivosSelecionados.push(file);
            }
        }
    }

    removerArquivo(index: number) {
        this.arquivosSelecionados.splice(index, 1);
    }
}
